/**
 * Created by Alexey Galkevych on 06.01.2022.
 */

export const setSlideOutContainer = swiper => {
  const {el, slides} = swiper;

  const wrapperCoords = el.getBoundingClientRect();

  if(Array.isArray(slides)) {
    slides.forEach(slide => {
      const slideCoords = slide.getBoundingClientRect();

      if(slideCoords.left < wrapperCoords.left || slideCoords.right > wrapperCoords.right) {
        slide.classList.add('slide-out');
      } else {
        slide.classList.remove('slide-out');
      }
    })
  }
}
